// Shared SEO helpers for blog/tool pages.
export const SITE = 'https://bankstatementreader.com'
export const DEFAULT_OG_IMAGE = `${SITE}/og-cover.png`

/** Absolute URL for a site-relative path. */
export function abs(path: string): string {
  if (/^https?:\/\//.test(path)) return path
  return `${SITE}${path.startsWith('/') ? path : `/${path}`}`
}

export interface Crumb {
  name: string
  path: string
}

/** schema.org BreadcrumbList from a crumb trail. */
export function breadcrumbJsonLd(crumbs: Crumb[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((c, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: c.name,
      item: abs(c.path),
    })),
  }
}
